function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg viewBox="0 0 28 21" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M17.965 2.33h5.94v11.636h-5.94V2.33m-4.119 11.636h14.179l-7.089 6.923-7.089-6.923m-9.751 4.943V7.273h5.94v11.636h-5.94M-.023 7.273L7.066.35l7.089 6.923H-.024" fillRule="evenodd" /></svg>;
});